module.exports = __webpack_public_path__ + "media/images/spinner-000b1918.svg";